import { Component } from '@angular/core';

@Component({
  selector: 'app-consultant-sign',
  templateUrl: './consultant-sign.component.html',
  styleUrls: ['./consultant-sign.component.scss']
})
export class ConsultantSignComponent {

}
